function helperGetDateMonth (date) {
  return date.getMonth()
}

module.exports = helperGetDateMonth



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/helperGetDateMonth.js
// module id = 204
// module chunks = 75